<script>
	import { fly } from 'svelte/transition'
	import { quadInOut } from 'svelte/easing'
	import { activeSlideIndex } from '../stores'
	import dlv from 'dlv'

	export let fields

	export let hideIntro
	let hiddenIntro = hideIntro

	let imageDir = dlv(window, 'boostOpts.imageDir')

	let width = 0
	let height = 0

	let coords = {
		x: 0,
		y: -3,
	}

	let overlayImages = []
	while (overlayImages.length < 3) {
		overlayImages.push({
			webp: `${imageDir}/slide-overlay.webp`,
			png: `${imageDir}/slide-overlay.png`,
		})
	}

	// pause if not active slide
	$: paused = !hideIntro || $activeSlideIndex !== 0

	if (!hideIntro) {
		// intro shown - set to hideintro after time to load video / headline
		setTimeout(() => {
			hideIntro = true
		}, 3550)
	}
</script>

{#if imageDir}
	<div class="top-overlay">
		{#each overlayImages as overlayImage}
			<picture>
				<source srcset={overlayImage.webp} type="image/webp" />
				<img src={overlayImage.png} alt="" />
			</picture>
		{/each}
	</div>
{/if}

<div
	class="slide-background"
	style="background-image:url(/wp-content/splash.jpg)"
	bind:offsetWidth={width}
	bind:offsetHeight={height}
	on:mousemove={e => {
		let { clientX, clientY } = e
		if (clientY < height) {
			coords = { x: (width / 2 - clientX) * -0.015, y: (height / 2 - clientY) * -0.015 }
		}
	}}>
	<video
		src={fields.vid}
		bind:paused
		muted
		loop
		playsinline
		autoplay={hiddenIntro}
		preload />
</div>
<div class="main">
	{#if hideIntro && fields.lineOne}
		<div class="inner-wrap" style="--ty:{coords.y}px; --tx:{coords.x}px;">
			<div in:fly={{ y: 25, duration: 1400, delay: hiddenIntro ? 100 : 530 }}>
				<h2>
					{fields.lineOne}
					<span
						in:fly={{ y: 15, duration: 1400, delay: hiddenIntro ? 200 : 730 }}>
						{#if fields.lineTwo}
							<em>{fields.lineTwo}</em>
						{/if}
					</span>
				</h2>
			</div>
		</div>
	{/if}
</div>

<button on:click={() => ($activeSlideIndex = $activeSlideIndex + 1)}>
	<span>&rsaquo;</span>
</button>
